module.exports = __webpack_public_path__ + "static/media/skill_matrix.c98cd80a.svg";